export default {
  title: "EGIS"
};
